module.exports = __webpack_public_path__ + "img/20201112-banner.57fa4484.jpg";